import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

interface filterStructure{
    "name": string,
    "value": any,
    "itemKey": string,
    "filterKey": string,
    "type": string,
    "op": string,
};

@Component({
  selector: 'app-rendicontazione-dettaglio-filter',
  templateUrl: './rendicontazione-dettaglio-filter.component.html',
  styleUrls: ['./rendicontazione-dettaglio-filter.component.css']
})
export class RendicontazioneDettaglioFilterComponent implements OnInit {
    @Input() emissioni: any[];
    @Output() updateFilterEmitter = new EventEmitter();

    resetContext: boolean = false;
    filterMap = null;
    filterFormGroup: FormGroup;
    emissioniSelectedControl: FormControl;

    constructor() { }

    ngOnInit() {
        this.resetContext = false;
        this.filterFormGroup = new FormGroup({
            emissioniSelectedControl: new FormControl([]),
            rapportoStileRadio: new FormControl({value: "normale"}),
            rapportoStileCheckbox: new FormControl({value: false, disabled: true}),
        });
        this.filterFormGroup.get('emissioniSelectedControl').valueChanges.subscribe(() => {
            if(!this.resetContext)
                this.updateFilter("emissioniSelectedControl");
        });
        this.filterFormGroup.get('rapportoStileRadio').valueChanges.subscribe(() => {
            if(this.filterFormGroup.get('rapportoStileRadio').value == 'accorpato'){
                this.filterFormGroup.get('rapportoStileCheckbox').enable();
            }else{
                this.filterFormGroup.get('rapportoStileCheckbox').setValue(false);
                this.filterFormGroup.get('rapportoStileCheckbox').disable();
            }
            if(!this.resetContext)
                this.updateFilter("rapportoStileRadio");
        });
        this.filterFormGroup.get('rapportoStileCheckbox').valueChanges.subscribe(() => {
            if(!this.resetContext)
                this.updateFilter("rapportoStileCheckbox");
        });
        this.resetFilters();
    }

    findEmissione(element: any){
        //console.log("emissioniSelected findEmissione", element, this);
        return element.id == this;
    }

    generateFilterMap(){
        if(!this.filterMap){
            this.filterMap = new Map();
        }
        let emissioniSelectedValue = [];

        if(this.filterFormGroup){
            emissioniSelectedValue = this.filterFormGroup.get('emissioniSelectedControl').value;
        }
        if(emissioniSelectedValue.length){
            console.log("emissioniSelected", emissioniSelectedValue);
            let emissioneLocal = null;
            let emissioniSelectedLocal = [];
            console.log("emissioniSelected emissioneSelected", emissioniSelectedValue, this.emissioni);
            emissioneLocal = this.emissioni.find(this.findEmissione, emissioniSelectedValue);
            if(emissioneLocal){
                console.log("emissioniSelected emissioneLocal", emissioneLocal);
                emissioniSelectedLocal.push(emissioneLocal);
                emissioniSelectedValue = emissioniSelectedLocal;
            }
            console.log("emissioniSelected emissioniSelectedValue", emissioniSelectedValue);
        }

        this.filterMap.set("emissioniSelected",
            {
                "name": "emissioniSelected",
                "object": null,
                "value": emissioniSelectedValue,
                "itemKey": "emissione_id",
                "filterKey": "id",
                "type": "array",
                "op": "in",
            },
        );

        if(this.filterFormGroup.get('rapportoStileRadio').value == "normale"){
            this.filterMap.set("rapportoStileRadio",
                {
                    "name": "rapportoStileRadio",
                    "object": null,
                    "value": null,
                    "itemKey": "",
                    "filterKey": "",
                    "type": "action",
                    "op": "action",
                },
            );
        }else{
            if(this.filterFormGroup.get('rapportoStileCheckbox').value){
                this.filterMap.set("rapportoStileRadio",
                    {
                        "name": "rapportoStileRadio",
                        "object": null,
                        "value": "accorpato-anno",
                        "itemKey": "",
                        "filterKey": "",
                        "type": "action",
                        "op": "action",
                    },
                );
            }else{
                this.filterMap.set("rapportoStileRadio",
                    {
                        "name": "rapportoStileRadio",
                        "object": null,
                        "value": "accorpato",
                        "itemKey": "",
                        "filterKey": "",
                        "type": "action",
                        "op": "action",
                    },
                );
            }
        }
    }

    updateFilter(fonte: string){
        this.generateFilterMap();
        let eventObject = {
            type: 'updateFiltersMap',
            data: this.filterMap,
        };
        console.log('UPDATE FILTERMAP', eventObject, fonte);
        this.updateFilterEmitter.emit(eventObject);
    }

    clearField(nameField: string){
        switch(nameField){
            case "emissioniSelected":{
                this.filterFormGroup.get('emissioniSelectedControl').setValue([]);
                break;
            }
        }
        this.updateFilter("clearField");
    }

    resetFilters(){
        //console.log('RESET FILTER pre', this.filterFormGroup.get('emissioniSelectedControl').value);
        //console.log('RESET FILTERMAP', this.filterMap);
        this.filterFormGroup.get('rapportoStileRadio').setValue("normale");
        this.filterFormGroup.get('rapportoStileCheckbox').setValue(false);
        this.filterFormGroup.get('emissioniSelectedControl').setValue([]);
        this.updateFilter("resetFilters");
        //console.log('RESET FILTER post', this.filterFormGroup.get('emissioniSelectedControl').value);
        return this.filterMap;
    }
}
